import React, { useState } from 'react';
import ReattemptConfirmationPopup from './ReattemptConfirmationPopup';
import DOMPurify from 'dompurify';
const ReattemptPopup = ({ certificate, onClose, onSubmit }) => {
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleReattempt = () => {
    setIsSubmitting(true);
    setError('');
    const payload = {
      action_type: "final_ph_approval",
      request_id: certificate.request_id,
      emp_id: certificate.emp_id,
      approval_status: "Reattempt",
      comments: comments.trim()
    };

    const success = onSubmit(payload, () => {
      setIsSubmitting(false);
      setShowConfirmation(false); 
      onClose();
    });

    if(success) {
      onClose();
    }
  };

  const handleEnableClick = () => {
    if (!comments.trim()) {
      setError('Comments are required');
      return;
    }
    setShowConfirmation(true);
  };

  if (showConfirmation) {
    return (
      <ReattemptConfirmationPopup
        employeeName={certificate.emp_name}
        onClose={() => {
          setShowConfirmation(false);
          onClose(); // Also close the entire flow if needed
        }}
        onConfirm={handleReattempt}
      />
    );
  }

  return (
    <div className="modal fade show d-block" 
    style={{
      display: 'block',
      backgroundColor: 'rgba(0,0,0,0.5)',
      backdropFilter: 'blur(2px)'
  }}
    >
      <div className="modal-dialog certification-modal approval-modal-width">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">
              Certification Reattempt - {certificate.emp_name}
            </h6>
            <button 
              type="button" 
              className="btn-close font-12" 
              aria-label="Close"
              onClick={onClose}
              disabled={isSubmitting}
            />
          </div>
          
          <div className="modal-body">
            <div className="row">
              <div className="col-md-8 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Certification Name
                </label>
                <div className="d-flex justify-content-start align-items-center">
                  <p className="font-12 semibold-text">{certificate.certificate_name}</p>
                  {certificate.client_dependency.Bool && (
                    <span className="client-badge ms-2">Client</span>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Provider
                </label>
                <p className="font-12 semibold-text">{certificate.provider}</p>
              </div>

              <div className="col-md-8 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Status
                </label>
                <p className="font-12 semibold-text">Reattempt</p>
              </div>

              {certificate.certificate_url && (
                <div className="col-md-4 mb-3">
                  <label className="font-12 mb-1 regular-text grey-text d-block">
                    Certificate
                  </label>
                  <a 
                    href={DOMPurify.sanitize(certificate.certificate_url)}
                    className="d-flex align-items-center bg-white p-2 border border-light-subtle rounded-3 shadow-sm text-decoration-none font-10 semibold-text text-dark"
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <img src="/Images/pdf-icon.svg" alt="pdf-icon" className="me-1" />
                    {certificate.certificate_name}
                  </a>
                </div>
              )}

              <div className="col-md-12 mb-3">
                <label className="font-12 mb-1 regular-text grey-text d-block">
                  Comments
                </label>
                <textarea 
                  className={`form-control font-12 comment-box ${error ? 'border-danger' : ''}`}
                  placeholder="Type your comments here..." 
                  value={comments}
                  onChange={(e) => setComments(e.target.value)}
                />
                {error && <small className="text-danger">{error}</small>}
              </div>
            </div>
          </div>

          <div className="modal-footer border-0">
            <div className="d-flex justify-content-end w-100">
              <button 
                className="btn hive-btn-secondary me-3"
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button 
                className="btn hive-btn-primary"
                onClick={handleEnableClick}
                disabled={isSubmitting}
              >
                Enable Reattempt
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReattemptPopup;